import PreviousPeriodDataCard from 'components/data-card/variants/previous-period-data-card/previous-period-data-card.component';
import { useSearchQueryContext } from 'components/search/search.hooks';
import SummaryCardBoundary from 'components/summary-card-boundary/summary-card-boundary.component';
import { useTranslation } from 'react-i18next';

const queryName = 'franchiseSummary';

const FranchiseSummaryCards = () => {
  const { t } = useTranslation();
  const { data } = useSearchQueryContext(queryName);

  const {
    activeMembers,
    activeMembersPercent,
    contributionRate,
    systemActiveMembersPercent,
    systemContributionRate,
  } = data;

  return (
    <SummaryCardBoundary queryName={queryName} expectedCount={5}>
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activeMembers.label')}
        value={activeMembers?.value}
        valueType={activeMembers?.cardType}
        previousPeriodPercent={activeMembers?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.activeMemberPercent.label')}
        value={activeMembersPercent?.value}
        valueType={activeMembersPercent?.cardType}
        previousPeriodPercent={activeMembersPercent?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t(
          'page.loyaltyPerformanceReport.systemActiveMemberPercent.label',
        )}
        value={systemActiveMembersPercent?.value}
        valueType={systemActiveMembersPercent?.cardType}
        previousPeriodPercent={systemActiveMembersPercent?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.contributionRate.label')}
        value={contributionRate?.value}
        valueType={contributionRate?.cardType}
        previousPeriodPercent={contributionRate?.comparisonNumber}
      />
      <PreviousPeriodDataCard
        title={t('page.loyaltyPerformanceReport.systemContributionRate.label')}
        value={systemContributionRate?.value}
        valueType={systemContributionRate?.cardType}
        previousPeriodPercent={systemContributionRate?.comparisonNumber}
      />
    </SummaryCardBoundary>
  );
};

export default FranchiseSummaryCards;
